/**
 * Ferienstart Familienvorrat — Cart Gift Selector
 *
 * Loaded globally in theme.liquid (like jb-limited-gift-progress.js) so the
 * functions stay available after the cart drawer re-renders via innerHTML.
 * The markup calls these via inline onclick handlers (which survive innerHTML
 * injection, unlike <script> tags).
 *
 * Adds the chosen gift (regular/paid variant) with a `_ferienstart_gift`
 * line-item property. The gift is made free by a Shopify discount (code or
 * automatic) configured in the Shopify admin — no discount handling in JS.
 */

/* eslint-disable no-unused-vars */

// Add a gift variant to the cart and refresh the drawer.
function ferienstartAddGift(variantId, cardEl) {
  if (!variantId || !cardEl) return;
  if (cardEl.classList.contains('is-loading')) return;

  cardEl.classList.add('is-loading');
  var btnText = cardEl.querySelector('.ferienstart-selector__add-btn-text');
  var btnLoading = cardEl.querySelector('.ferienstart-selector__add-btn-loading');
  if (btnText) btnText.style.display = 'none';
  if (btnLoading) btnLoading.style.display = 'inline-flex';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: { _ferienstart_gift: 'true' }
      }]
    })
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Failed to add gift to cart');
      return response.json();
    })
    .then(function () {
      // Re-render the cart drawer — Liquid re-evaluates and moves to the success state.
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(function (error) {
      console.error('FerienstartGiftSelector: Error adding gift', error);
      cardEl.classList.remove('is-loading');
      if (btnText) btnText.style.display = 'inline';
      if (btnLoading) btnLoading.style.display = 'none';
    });
}

// Select a Premium Cup color: highlight the swatch, store the variant,
// swap the card image to the variant image, enable the button.
function ferienstartSelectColor(swatchEl) {
  var card = swatchEl.closest('.ferienstart-selector__product');
  if (!card) return;

  var swatches = card.querySelectorAll('.ferienstart-selector__swatch');
  for (var i = 0; i < swatches.length; i++) {
    swatches[i].classList.remove('is-selected');
  }
  swatchEl.classList.add('is-selected');

  card.dataset.selectedVariantId = swatchEl.dataset.variantId || '';

  var cardImage = card.querySelector('.ferienstart-selector__product-image img');
  if (cardImage && swatchEl.dataset.image) {
    cardImage.src = swatchEl.dataset.image;
  }

  var btn = card.querySelector('.ferienstart-selector__cup-btn');
  if (btn) {
    btn.disabled = false;
  }
}

// Add the currently selected Premium Cup color.
function ferienstartAddSelectedCup(btnEl) {
  var card = btnEl.closest('.ferienstart-selector__product');
  if (!card) return;
  var variantId = card.dataset.selectedVariantId;
  if (!variantId) return; // no color chosen yet
  ferienstartAddGift(variantId, card);
}

/**
 * Countdown ticker.
 *
 * One persistent interval (started once for the whole page) that each second
 * finds every `.ferienstart-countdown[data-ends]` currently in the DOM and
 * updates its Tage/Std/Min/Sek cells. Because it re-queries the DOM each tick,
 * it keeps working when the cart drawer re-injects the markup via innerHTML —
 * and because it's a single global interval, re-renders never stack timers.
 */
(function () {
  if (window.__ferienstartCountdownStarted) return;
  window.__ferienstartCountdownStarted = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function setCell(root, key, value) {
    var cell = root.querySelector('[data-cd="' + key + '"]');
    if (cell) cell.textContent = value;
  }

  function tick() {
    var timers = document.querySelectorAll('.ferienstart-countdown[data-ends]');
    for (var i = 0; i < timers.length; i++) {
      var root = timers[i];
      var end = new Date(root.getAttribute('data-ends')).getTime();
      if (isNaN(end)) continue;

      var diff = end - Date.now();
      if (diff <= 0) {
        setCell(root, 'd', '0');
        setCell(root, 'h', '00');
        setCell(root, 'm', '00');
        setCell(root, 's', '00');
        root.classList.add('is-ended');
        continue;
      }

      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;

      setCell(root, 'd', '' + d);
      setCell(root, 'h', pad(h));
      setCell(root, 'm', pad(m));
      setCell(root, 's', pad(s));
    }
  }

  tick();
  setInterval(tick, 1000);
})();
